import { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";

import {
  Dashboard,
  Calendar,
  plus,
  fileicon,
  SendIcon,
  GreenTickCircle,
  Recording,
  Complete,
  CrossCircled,
  bookingIcon,
  RsIcon,
  Setting,
  RightArw,
  Bookings,
  Report,
  Dashboard2Icon,
  anylitics,
  AtmCardIcon,
  Support,
  Headset,
  CrossWhite,
  BookingSidebar,
  Ruppe2,
  CompletedEvent,
  LiveEvent,
  Threeline,
  Chaticon,
  Profile1,
  plusgray,
  Notification,
  Wallet,
  InfluencerIcon,
  PersonGray,
  bed,
  Logo,
  Rightarrow,
  Downarrow2,
} from "../../assests/ExportImageIcon";

import "./sidebar.css";

const VenueSidebar = ({ collapsed }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const [openMenu, setOpenMenu] = useState(null);

  const handleClick = (name, route = null) => {
    if (route) navigate(route);
  };

  const handleDropdownClick = (name) => {
    if (collapsed) return;

    setOpenMenu((prev) => (prev === name ? null : name));
  };

  const isActive = (name) => {
    switch (name) {
      case "venue-dashboard":
        return (
          location.pathname === "/venue-dashboard" ||
          location.pathname.startsWith("/venue-dashboard/")
        );

      case "my-listings":
        return (
          location.pathname === "/my-listings" ||
          location.pathname.startsWith("/my-listings/") ||
          location.pathname === "/my-listings-detail" ||
          location.pathname.startsWith("/my-listings-detail/")
        );

      case "create-listing":
        return (
          location.pathname === "/create-listing" ||
          location.pathname.startsWith("/create-listing/")
        );

      case "venue-booking":
        return (
          location.pathname === "/venue-booking" ||
          location.pathname.startsWith("/venue-booking-detail")
        );

      case "proposals":
        return (
          location.pathname === "/proposal" ||
          location.pathname.startsWith("/proposal/")
        );

      case "negotiation":
        return (
          location.pathname === "/negotiation" ||
          location.pathname.startsWith("/negotiation/")
        );

      case "earnings":
        return (
          location.pathname === "/earning-payout" ||
          location.pathname.startsWith("/earning-payout/")
        );

      case "venue-profile":
        return (
          location.pathname === "/venue-profile" ||
          location.pathname.startsWith("/venue-profile-edit")
        );

      case "bank-details":
        return (
          location.pathname === "/venue-bank-detail" ||
          location.pathname.startsWith("/venue-bank-detail/")
        );

      case "venue-settings":
        return (
          location.pathname === "/venue-settings" ||
          location.pathname.startsWith("/venue-settings/")
        );

      case "support-tickets":
        return (
          location.pathname === "/requests" ||
          location.pathname.startsWith("/requests/")
        );

      default:
        return false;
    }
  };

  const isMyListingActive =
    location.pathname === "/my-listings" ||
    location.pathname.startsWith("/my-listings/") ||
    location.pathname === "/my-listings-detail" ||
    location.pathname.startsWith("/my-listings-detail/") ||
    location.pathname === "/create-listing" ||
    location.pathname.startsWith("/create-listing/");

  const isOpen = (name) => openMenu === name;

  return (
    <div className={`sidebar ${collapsed ? "collapsed" : ""}`}>
      <div onClick={() => navigate("/venue-dashboard")} className="logo">
        <img
          src={Logo}
          alt="Travel Booking"
          style={{
            maxHeight: "48px",
            maxWidth: "100%",
            objectFit: "contain",
            cursor: "pointer",
          }}
        />
      </div>

      <ul className="menu">
        {/* Venue Vendor */}
        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("venue-dashboard") ? "active" : ""
            }`}
            onClick={() => handleClick("venue-dashboard", "/venue-dashboard")}
          >
            <img src={Dashboard} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Dashboard</span>}
          </div>
        </li>

        <li className="menu-item showdrpdown">
          <div
            className={`menu-link ${isMyListingActive ? "active" : ""}`}
            onClick={() => handleDropdownClick("My Listing")}
            style={{ cursor: "pointer" }}
          >
            <img src={Threeline} className="menu-icon-img" alt="" />

            {!collapsed && (
              <>
                <span className="menu-text">My Listing</span>

                <span className="ms-auto">
                  {isOpen("My Listing") ? (
                    <img src={Downarrow2} alt="" />
                  ) : (
                    <img src={Rightarrow} alt="" />
                  )}
                </span>
              </>
            )}
          </div>

          {!collapsed && isOpen("My Listing") && (
            <ul className="submenu">
              <li
                onClick={() => handleClick("my-listings", "/my-listings")}
                className={isActive("my-listings") ? "active" : ""}
              >
                <img src={Threeline} className="menu-icon-img" alt="" />

                <span className="menu-text">Listing</span>
              </li>

              <li
                onClick={() => handleClick("create-listing", "/create-listing")}
                className={isActive("create-listing") ? "active" : ""}
              >
                <img src={plusgray} className="menu-icon-img" alt="" />

                <span className="menu-text">Create Listing</span>
              </li>
            </ul>
          )}
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("venue-booking") ? "active" : ""}`}
            onClick={() => handleClick("venue-booking", "/venue-booking")}
          >
            <img src={Bookings} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Bookings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("proposals") ? "active" : ""}`}
            onClick={() => handleClick("proposals", "/proposal")}
          >
            <img src={Support} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Proposals</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("negotiation") ? "active" : ""}`}
            onClick={() => handleClick("negotiation", "/negotiation")}
          >
            <img src={Chaticon} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Negotiation Chat</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("earnings") ? "active" : ""}`}
            onClick={() => handleClick("earnings", "/earning-payout")}
          >
            <img src={Ruppe2} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Earnings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("venue-profile") ? "active" : ""}`}
            onClick={() => handleClick("venue-profile", "/venue-profile")}
          >
            <img src={Profile1} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Profile</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${isActive("bank-details") ? "active" : ""}`}
            onClick={() => handleClick("bank-details", "/venue-bank-detail")}
          >
            <img src={AtmCardIcon} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Bank Detail</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("venue-settings") ? "active" : ""
            }`}
            onClick={() => handleClick("venue-settings", "/venue-settings")}
          >
            <img src={Setting} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Settings</span>}
          </div>
        </li>

        <li className="menu-item">
          <div
            className={`menu-link ${
              isActive("support-tickets") ? "active" : ""
            }`}
            onClick={() => handleClick("support-tickets", "/requests")}
          >
            <img src={Headset} className="menu-icon-img" alt="" />

            {!collapsed && <span className="menu-text">Support & Ticket</span>}
          </div>
        </li>
      </ul>
    </div>
  );
};

export default VenueSidebar;
